import ScanInboxButton from './ScanInboxButton'

export default ScanInboxButton
